<template>
  <div class="payment-error">
    <div class="error">
      <AmIconMaterial
        class="error__icon text--red"
        name="warning"
        size="md"
      />
      <AmTypography
        :text="$t('steps.payment.paymentProcessError.title')"
        text-color="error"
        typography-style="l6"
        weight="bold"
      />
    </div>
    <div class="sub-error">
      <AmTypography
        :text="$t('steps.payment.paymentProcessError.subTitle')"
        text-color="error"
        typography-style="l6"
        weight="bold"
      />
    </div>
    <div>
      <PurchaseSummary
        :installmentSeletedLabel="installmentSeletedLabel"
        :paymentType="paymentType"
      />
    </div>
    <AmButton
      :class="[disabledTryAgain(), 'tryagain']"
      :label="tryAgainButtonText"
      size="xl"
      full-width
      :icon="tryAgainButtonIcon"
      :disabled="enabledTryAgainPayment"
      @click="returnPaymentCardDataPayment()"
    >
      <template
        v-if="loadingGlobal"
        #content
      >
        <AmLoading
          class="loading--white"
          :AmLoaderSize="35"
        />
      </template>
    </AmButton>

    <AmTypography
      v-if="isPaymentBilletOrPix"
      :class="['return', `text--${theme.color}`]"
      typography-style="l5"
    >
      <template #default>
        <div @click="returnPaymentTypeErrorBilletOrPix()">
          {{ $t('return') }}
        </div>
      </template>
    </AmTypography>
    <AmTypography
      v-else
      :class="['return', `text--${theme.color}`]"
      typography-style="l5"
    >
      <template #default>
        <div @click="returnPaymentCardDataPayment()">
          {{ $t('return') }}
        </div>
      </template>
    </AmTypography>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapState, mapActions } from 'vuex'
import PurchaseSummary from '@/views/Checkout/partials/PurchaseSummary/PurchaseSummary.vue'

export default {
  name: 'PaymentErrorShopify',
  components: {
    PurchaseSummary,
  },
  mixins: [themeMixin, currencyFilterMixin],
  props: {
    paymentType: {
      type: String,
    },
    installmentSelected: {
      type: [String, Object],
    },
  },
  data() {
    return {
      enabledTryAgainPayment: true,
      paymentTypesChangePaymentButton: ['billet', 'pix'],
    }
  },
  computed: {
    ...mapState('Checkout', {
      loadingGlobal: (state) => state.globalLoading,
    }),
    currentPaymentTypeSelected() {
      return this.paymentType
    },
    isPaymentBilletOrPix() {
      return this.paymentTypesChangePaymentButton.includes(this.currentPaymentTypeSelected)
    },
    installmentSeletedLabel() {
      return this.installmentSelected.label
    },
    tryAgainButtonText() {
      const paymentTexts = {
        card: this.$t('steps.payment.tryAgainPayment.card'),
        billet: this.$t('steps.payment.tryAgainPayment.billet'),
        pix: this.$t('steps.payment.tryAgainPayment.pix'),
      }

      return paymentTexts[this.currentPaymentTypeSelected]
    },
    tryAgainButtonIcon() {
      const paymentTexts = {
        card: 'shopping_bag',
        billet: 'rotate_right',
        pix: 'pix',
      }

      return {
        name: paymentTexts[this.currentPaymentTypeSelected],
        position: 'left',
        type: 'material',
        size: 'xl',
      }
    },
  },
  watch: {
    loadingGlobal: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.enabledTryAgainPayment = true
          return newValue
        }

        this.enabledTryAgainPayment = false
        return newValue
      },
    },
  },
  methods: {
    ...mapActions('Card', ['resetCard']),
    disabledTryAgain() {
      return this.enabledTryAgainPayment ? '' : this.theme.color
    },
    returnPaymentCardDataPayment() {
      this.$emit('returnWithRecaptchaAttemptsCount')
      this.$emit('returnPaymentCardDataPayment')
      this.resetCard()()
    },
    returnPaymentTypeErrorBilletOrPix() {
      this.$emit('returnPaymentTypeErrorBilletOrPix')
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-error {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .tryagain {
    margin-top: 20px;
    margin-bottom: 12px;
  }

  .error {
    display: flex;
    justify-content: center;
    margin-top: 10px;

    &__icon {
      margin-right: 10px;
    }
  }

  .sub-error {
    display: flex;
    justify-content: center;
    margin: 3px 0 27px 0;
    text-align: center;
  }

  .return {
    cursor: pointer;
    margin-top: 24px;
    text-align: center;
  }
}
</style>
